import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuotingService } from './quoting.service';

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		QuotingService
	]
})
export class QuotingServiceModule { }